import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "flex-grow flex flex-col space-y-3" }
const _hoisted_2 = { class: "flex flex-col space-y-3 p-3" }
const _hoisted_3 = { class: "flex flex-col md:flex-row space-x-3" }
const _hoisted_4 = { class: "flex-grow flex flex-col items-center space-y-3 my-12" }
const _hoisted_5 = { class: "text-2xl font-bold" }
const _hoisted_6 = { class: "flex space-x-3 w-64" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "w-10 h-6 bg-yellow-400 rounded" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "flex-grow" }, "Incoming", -1)
const _hoisted_9 = { class: "font-bold" }
const _hoisted_10 = { class: "flex space-x-3 w-64" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "w-10 h-6 bg-blue-600 rounded" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "flex-grow" }, "Outgoing", -1)
const _hoisted_13 = { class: "font-bold" }
const _hoisted_14 = { class: "w-1/2" }
const _hoisted_15 = { class: "flex justify-end items-center space-x-2" }
const _hoisted_16 = { class: "flex flex-col space-y-3" }
const _hoisted_17 = { class: "flex-grow text-left cursor-pointer text-lg font-bold bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-900 rounded-md p-3 border border-transparent" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Chart = _resolveComponent("Chart")!
  const _component_MultiFilterButton = _resolveComponent("MultiFilterButton")!
  const _component_DisclosureButton = _resolveComponent("DisclosureButton")!
  const _component_ActionLine = _resolveComponent("ActionLine")!
  const _component_DisclosurePanel = _resolveComponent("DisclosurePanel")!
  const _component_Disclosure = _resolveComponent("Disclosure")!
  const _component_DashboardCard = _resolveComponent("DashboardCard")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createVNode(_component_DashboardCard, { title: "Transactions" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.$filters.number.standard(_ctx.actions.length)) + " transaction" + _toDisplayString(_ctx.actions.length !== 1 ? 's' : ''), 1),
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _hoisted_8,
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$filters.number.standard(_ctx.incoming)), 1)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _hoisted_12,
                _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$filters.number.standard(_ctx.outgoing)), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_Chart, {
                class: "chart",
                option: _ctx.transactionTypeOption,
                autoresize: ""
              }, null, 8, ["option"])
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_MultiFilterButton, {
              modelValue: _ctx.directionFilter,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.directionFilter) = $event)),
              class: "w-32",
              label: "Direction",
              items: ['All', ..._ctx.directions],
              highlight: e => e !== 'All'
            }, null, 8, ["modelValue", "items", "highlight"]),
            _createVNode(_component_MultiFilterButton, {
              modelValue: _ctx.actionKindFilter,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.actionKindFilter) = $event)),
              class: "w-48",
              label: "Type",
              items: ['All', ..._ctx.actionKinds],
              display: x => (x === 'All' ? x : _ctx.humanizeActionKind(x)),
              highlight: e => e !== 'All'
            }, null, 8, ["modelValue", "items", "display", "highlight"])
          ]),
          _createElementVNode("div", _hoisted_16, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedByDate, (group) => {
              return (_openBlock(), _createBlock(_component_Disclosure, {
                as: "div",
                key: group.date,
                class: "flex flex-col",
                defaultOpen: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DisclosureButton, {
                    as: "h4",
                    class: "flex"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("button", _hoisted_17, _toDisplayString(group.dateText), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_Transition, {
                    "enter-active-class": "transition duration-100 ease-out",
                    "enter-from-class": "transform scale-95 opacity-0",
                    "enter-to-class": "transform scale-100 opacity-100",
                    "leave-active-class": "transition duration-75 ease-out",
                    "leave-from-class": "transform scale-100 opacity-100",
                    "leave-to-class": "transform scale-95 opacity-0"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DisclosurePanel, { class: "flex flex-col divide-y divide-gray-100 dark:divide-gray-700 mt-2 truncate" }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.actions, (action, i) => {
                            return (_openBlock(), _createBlock(_component_ActionLine, {
                              key: i,
                              action: action
                            }, null, 8, ["action"]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ])
        ])
      ]),
      _: 1
    })
  ]))
}